import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section className="py-16 bg-primary">
      <div className="container-custom mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Experience the Magic of Wildlife?
          </h2>
          <p className="text-white text-lg mb-8 opacity-90">
            Book your dream safari or wildlife getaway today and create memories that will last a lifetime.
            Our expert guides and personalized service ensure an unforgettable experience.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/tours"
              className="btn bg-white text-primary hover:bg-gray-100 font-semibold px-8 py-3 rounded-md"
            >
              Browse Tours
            </Link>
            <Link
              to="/contact"
              className="btn border-2 border-white text-white hover:bg-white hover:text-primary font-semibold px-8 py-3 rounded-md"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
